var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/icons/reachmd_icon.png"),"alt":"reachmd icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }